export default "__VITE_ASSET__BeFy5mQx__"